export const shouldIntegrateSentry = (): boolean =>
  process.env.REACT_APP_ENVIRONMENT === 'production' ||
  process.env.REACT_APP_ENVIRONMENT === 'preprod';
